export default "__VITE_ASSET__BXt26zjV__"